module.exports = __webpack_public_path__ + "img/index-4.d4d02ea7.png";